import { useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="flex w-full items-center gap-4 px-4 py-3 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" style={{ lineHeight: 1 }} />
          </span>
          <span className="flex flex-col leading-tight">
            <h1 className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
              黑料大瓜
            </h1>
            <span className="font-label text-[10px] tracking-wide text-foreground-500 md:text-[11px]">
              细节分析 · 完整时间线 · 内幕深扒
            </span>
          </span>
        </a>

        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <div className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 md:flex">
            <i className="ri-search-line h-4 w-4 text-foreground-400" style={{ lineHeight: 1 }} />
            <input
              type="text"
              placeholder="搜瓜料 / 时间线 / 当事人"
              aria-label="搜索瓜料"
              className="w-40 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400 xl:w-52"
            />
          </div>

          <button
            type="button"
            className="hidden cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 md:flex"
          >
            <i className="ri-notification-3-line h-4 w-4" style={{ lineHeight: 1 }} />
            订阅更新
          </button>

          <button
            type="button"
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
          >
            提交线索
          </button>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} style={{ lineHeight: 1 }} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="mt-3 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line h-4 w-4 text-foreground-400" style={{ lineHeight: 1 }} />
            <input
              type="text"
              placeholder="搜瓜料 / 时间线 / 当事人"
              aria-label="搜索瓜料"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="button"
            className="mt-3 w-full cursor-pointer rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            提交线索
          </button>
        </div>
      )}
    </header>
  );
}